<template>
    <Datepicker
        v-model="modelValue"
        :tabindex="tabindex"
        :class="[`forms__field_input--${field?.type ?? 'datetime'}`]"
        :time="true"
        :nullable="typeof field?.nullable !== 'undefined' ? field.nullable : props.nullable"
        :nullable-time="typeof field?.nullableTime !== 'undefined' ? field.nullableTime : false"
        :required="field?.required ? parseInt(field.required) === 1 : props.required"
        :size="props.size"
        :disabled="props.disabled"
    ></Datepicker>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: String,
});

const props = withDefaults(defineProps<FieldComponent>(), {});
</script>
